import { IonRow, IonCol } from "@ionic/react";
import React, { ReactElement } from "react";
export const AppLayout:React.FC<{children:ReactElement}> = ({children})=> <IonRow>
<IonCol sizeMd="2" sizeLg="3" sizeSm="1" sizeXs="0" />
<IonCol sizeMd="8" sizeLg="6" sizeSm="10" sizeXs="12">
    {children}
</IonCol>
<IonCol sizeMd="2" sizeLg="3" sizeSm="1" sizeXs="0" />
</IonRow>
